/*
 *
 * TechnicalErrorModal
 *
 * @version 1.0.0
 * @author Pietro Bertuccelli
 * @since 07-Nov-2024
*/

import TechnicalErrorModal from './TechnicalErrorModalContainer'

export default TechnicalErrorModal
